import { EyeCloseIcon, EyeIcon } from "components/vectors";
import React, { useState }  from "react";

const FloatingPasswordInput = ({ value,register, label, name, onChange,hasError,errorMessage,...inputProps  }) => {
    const [show,setShow] = useState(false);
  return (
  
    <div className={`floating__label__content ${hasError?'error__input':''}`}>
      
      <div className="password__input__wrapper">
      <input className="floating__input"
      value={value}
      name={name}
      ref={register}
      type={show?'text':'password'} 
      onChange={onChange}
      {...inputProps }
      placeholder=" "/>
      <span className="password__toggle">
        {
          show?(
            <EyeCloseIcon
              hasError={hasError}
              classNames="cursor__pointer" 
              onClick={()=>setShow(prev=>!prev)} />
          ):(
            <EyeIcon 
            hasError={hasError}
            classNames="cursor__pointer" 
            onClick={()=>setShow(prev=>!prev)} />
            
          )
        }
        </span>
      
      <label className="floating__label">{label}</label>
      
      </div>
      {hasError?(
      <span className="error__message">{errorMessage}</span>
    ):(null)}
      
  </div>
    
  );
}

export default FloatingPasswordInput;